import React, { useMemo } from 'react';
import { Field, useField } from 'react-final-form';

import AccessContainers from '../../../components/access-containers/AccessContainers';
import useAIChatsOptions from './useAIChatsOptions';

function AIChatsContainer({ search = '', fieldName = 'assignedAIChats', disabled }) {
  const assignedAIChatsField = useField(fieldName);

  const { options: aiChatsOptions, isLoading } = useAIChatsOptions({ search });

  const handleRemoveAIChat = (aiChat) => {
    assignedAIChatsField.input.onChange(assignedAIChatsField.input.value.filter((a) => a.id !== aiChat.id));
  };

  const handleAssignAIChat = (aiChat) => {
    assignedAIChatsField.input.onChange([...assignedAIChatsField.input.value, aiChat]);
  };

  const inactiveAIChats = useMemo(
    () =>
      aiChatsOptions.filter(
        (aiChat) => !assignedAIChatsField.input.value.some((activeAIChat) => activeAIChat.id === aiChat.id),
      ),
    [assignedAIChatsField.input.value, aiChatsOptions],
  );

  return (
    <Field name={fieldName}>
      {({ input }) => (
        <AccessContainers
          onInactive={handleRemoveAIChat}
          onActive={handleAssignAIChat}
          inactive={inactiveAIChats}
          active={input.value}
          disabled={disabled}
          isLoading={isLoading}
          searchStr={search}
        />
      )}
    </Field>
  );
}

export default AIChatsContainer;
